import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { adminsEnterpriseCraete, cancelSubscriptionRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList } from '../constants';

type useCancelSubscriptionProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCancelSubscription = ({
    setErrorText = () => { },
}: useCancelSubscriptionProps) => {
    const client = useQueryClient();
    const { mutate: cancelSubscription, isLoading: isCancelSubcription } =
        useMutation({
            mutationFn: (variables: {
                immediately_or_end?: boolean;
                time?: string;
                user_id: number | string;
                is_enterprise?: boolean;
            }) =>
                axiosInstance
                    .post(cancelSubscriptionRoute, variables, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries(adminEmployersList);
                client.invalidateQueries(adminEnterprisesList);
                setErrorText('');
            },
            onError: (data: any) => {
                setErrorText(data?.response?.data?.message || errorMessage);
            },
        });
    return {
        cancelSubscription,
        isCancelSubcription,
    };
};
